export function setupHelpPanel({ elements }) {
  const openHelpPanel = () => {
    elements.panel?.classList.remove("hidden");
    elements.panel?.setAttribute("aria-hidden", "false");

    if (elements.closeButton) {
      elements.closeButton.focus();
    }
  };

  const closeHelpPanel = () => {
    const shouldRestoreFocus = elements.panel?.contains(document.activeElement);
    elements.panel?.classList.add("hidden");
    elements.panel?.setAttribute("aria-hidden", "true");
    if (shouldRestoreFocus) elements.toggleButton?.focus();
  };

  elements.toggleButton?.addEventListener("click", () => {
    if (elements.panel?.classList.contains("hidden")) {
      openHelpPanel();
    } else {
      closeHelpPanel();
    }
  });

  elements.closeButton?.addEventListener("click", closeHelpPanel);

  return {
    openHelpPanel,
    closeHelpPanel
  };
}
